import $ from '/js/header/jquery';

$(() => {
    // urlParam에서 title=mailService일경우 제 9 조 (메일 서비스)로 스크롤 이동
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get('title') === 'mailService') {
        const target = $('#serviceGuide9');
        if (target.length) {
            $('html, body').animate({
                scrollTop: target.offset().top - 100
            }, 500);
        } else {
            console.error('serviceGuide9 element not found');
        }
    }
})